import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { Contactenos } from "./contactenos.component";
import { ContactenosService } from "./contactenos.service";
import { UtilService } from "../../../components/common/utils/util.service"
import {DataTableModule} from "angular2-datatable";
import {FileUploadModule} from "ng2-file-upload/ng2-file-upload";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";

@NgModule({
    declarations: [Contactenos],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        FileUploadModule],
    providers: [ContactenosService, UtilService,ConsultarUsuarioMasivos],
    exports: [Contactenos]
})

export class ContactenosModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/contactenos/contactenos.module.ts